module.exports = __webpack_public_path__ + "static/media/search.efe0b9d0.png";